import { render, staticRenderFns } from "./ShrinkageTable.vue?vue&type=template&id=cd21147e&scoped=true"
import script from "./ShrinkageTable.vue?vue&type=script&lang=js"
export * from "./ShrinkageTable.vue?vue&type=script&lang=js"
import style0 from "./ShrinkageTable.vue?vue&type=style&index=0&id=cd21147e&prod&lang=scss&scoped=true"
import style1 from "./ShrinkageTable.vue?vue&type=style&index=1&id=cd21147e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd21147e",
  null
  
)

export default component.exports